const Icon = ({name, size, weight, color, className}) => {
    return (
        <i className={`${name ? `ri-${name}` : ''} ${size && `text-${size}`} ${weight ? `font-${weight}` : ''} ${color ? `text-${color}` : ''} ${className ? className : ''}`}></i>
    )
}

export default Icon;